module.exports = __webpack_public_path__ + "static/media/17.5cf7284d.jpg";